/* eslint-disable @typescript-eslint/no-unused-vars */
import Countdown from "components/CountdownV2";
import { usePoisBountyContext } from "components/PoisBountyWidgetV3/context";
import { useGoogleAnalyticsContext } from "contexts";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { useAppDispatch, useAppSelector, useLinks } from "hooks";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { onPBV3change, selectPoisBountyV3State } from "redux/slices";
import { RootState } from "redux/store";
import { Container, getTimerStyle } from "./styles";
import { useNavigate } from "react-router-dom";
import CyclesIndicator from "../CyclesIndicator";

interface TimerProps {}

export const Timer: React.FC<TimerProps> = () => {
	const links = useLinks();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { nowTime } = useWebStoreContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { isPortrait, isPageVariant } = usePoisBountyContext();
	const { eventEnded, tracker, allRewardsCollected } = useAppSelector(
		selectPoisBountyV3State
	);
	const showLabels = useSelector(
		(state: RootState) => state.debug.showDebugLabels
	);
	const endEventTime = tracker?.endTime || "";
	// @ts-expect-error
	const showCountDown = typeof nowTime._tzm !== "undefined" && tracker?.endTime;

	return (
		<>
			<Container>
				<div>
					{showCountDown && (
						<Countdown
							startTime={nowTime}
							endTime={endEventTime}
							style={getTimerStyle(isPortrait)}
							hideTimer={eventEnded || allRewardsCollected}
							text={
								eventEnded || allRewardsCollected ? "Event Ended" : undefined
							}
							onEnd={() => {
								if (typeof tracker !== "undefined") {
									setTimeout(() => {
										dispatch(
											onPBV3change({ eventEnded: true, eventActive: false })
										);
										if (!allRewardsCollected) {
											reportPlaygamiEvent("tp.web_frontend", {
												event_name: "event_user_end",
												event_type: "pois_bounty_v3",
												action: "pb_user_end",
												source: "pois_bounty_v3",
												section_name: "time_expired",
												type:
													tracker?.eventType === "user" ? "personal" : "club",
												event_id: tracker?.eventId
											});
										}
										/* if (location.pathname === links.pois_bounty.path) {
									navigate(links.home.path);
								} */
									}, 1000);
								}
							}}
						/>
					)}
					<CyclesIndicator />
					{showLabels &&
						showCountDown &&
						isPageVariant &&
						(eventEnded || allRewardsCollected) && (
							<Countdown
								style={getTimerStyle(isPortrait)}
								startTime={nowTime}
								endTime={endEventTime}
								text="Debug time: "
								onEnd={() => {}}
							/>
						)}
				</div>
			</Container>
		</>
	);
};
